module.exports = __webpack_public_path__ + "img/user-16.6783bc5e.svg";